module.exports = __webpack_public_path__ + "static/img/list_empty.b83b9e83.png";